import React, { useEffect, useRef, useState } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';

// utils
import { shuffle, useDebounce } from '@utils/methods';

// picture
import rptgenLogo from '@images/login/logo-image.jpg';
import rptgenLogo2 from '@images/login/logo-image2.jpg';
import rptgenLogo3 from '@images/login/logo-image3.jpg';
import rptgenLogo4 from '@images/login/logo-image4.jpg';

import rptgenLogoTablet from '@images/login/logo-tablet.png';

// styling
import './index.less';

const backgroundImg = shuffle([rptgenLogo, rptgenLogo2, rptgenLogo3, rptgenLogo4])[0];

const Captcha = () => {
  const [ht, setHt] = useState('');
  const [hkey, setHkey] = useState('');
  const cRef = useRef(null);

  const onLoad = () => {
    cRef.current.execute();
  };

  const handleVerificationSuccess = (token, ekey) => {
    // console.log('[tk] ', token);
    // console.log('[ek] ', ekey);
    setHt(token);
    setHkey(ekey);

    if (window.flutter_inappwebview) {
      const bread = { token, ekey };
      window.flutter_inappwebview.callHandler('captchaHandler', JSON.stringify(bread));
    }

    if (window.captchaHandler) {
      const bread = { token, ekey };      
      window.captchaHandler.postMessage(JSON.stringify(bread));      
    }


  };

  useEffect(() => {
    return () => {
      cRef.current.resetCaptcha();
    };
  }, []);

  return (              
    <div className="flex-center" style={{ marginTop: 40, padding: '0 0px' }}>
      <HCaptcha //
        sitekey={process.env.REACT_APP_HC_SKEY}
        onVerify={handleVerificationSuccess}
        ref={cRef}
      />
    </div>
  );
};

export default Captcha;
